module.exports = __webpack_public_path__ + "static/media/Agenda13.23fb5353.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/Agenda/Agenda13.png
// module id = 1978
// module chunks = 0